import React from 'react';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Navigation from './Navigation';
import { ToastContainer } from 'react-toastify';
import { useLocation } from 'react-router-dom';

const App = () => {
  let location = useLocation();
  return (
    <div className='App'>
      <ToastContainer theme="colored" position="top-center" />
      {
        location.pathname === "/" ||
          location.pathname === "/marche" ||
          location.pathname === "/contact" ||
          location.pathname === "/restaurant" ||
          location.pathname === "/restaurant/..." ||
          location.pathname === "/inscriptionClient" ||
          location.pathname === "/loginClient" ||
          location.pathname === "/loginRestaurant" ||
          location.pathname === "/resetRestaurant/:token" ||
          location.pathname === "/loginSociete" ||
          location.pathname === "/finaliserReservation" ||
          location.pathname === "/confirmation" ||
          location.pathname === "/annulation" ||
          location.pathname === "/reserverSansCritere/:idRestaurant"
          ?
          <header>
            <NavBar />
          </header>
          : ''}
      <Navigation />
      {
        location.pathname === "/" ||
          location.pathname === "/contact" ||
          location.pathname === "/restaurant"
          ?
          <Footer />
          : ''}
    </div>
  )
}

export default App 
